import { promisifyWxSdk } from './common'
/**
 *保存media
 *
 * @returns
 */
async function saveMedia(localId) {
    return await Promise.all([translateVoice(localId), uploadVoice(localId)])
}
async function translateVoice(localId) {
    const { translateResult } = await promisifyWxSdk('translateVoice', {
        localId,
        isShowProgressTips: 0
    })
    if (translateResult && translateResult.length > 2) {
        return translateResult
    } else {
        throw Error('说话时间太短')
    }
}
function uploadVoice(localId) {
    return new Promise(async (resolve, reject) => {
        promisifyWxSdk('uploadVoice', {
            localId,
            isShowProgressTips: 0
        })
            .then(({ serverId }) => {
                cw('saveMedia', resolve, reject, serverId)
            })
            .catch(reject)
    })
}
export { saveMedia }
